import React, { useState } from 'react';

import SpinnerIcon from 'icons/spinner.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import TextButton from 'components/application/buttons/TextButton';
import ConditionalWrapper from 'components/application/ConditionalWrapper';
import RichTextEditor from 'components/application/RichTextEditor';
import Tooltip from 'components/application/Tooltip';

export default function SubmittableStepField({
  onCancel,
  onChange,
  onSubmit,
  placeholder,
  submitButtonText,
  value,
}) {
  const [isLoading, setIsLoading] = useState(true);

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const isSubmittable = Boolean(value) && value.trim().length > 0;

  return (
    <>
      <RichTextEditor
        name='method_step[text]'
        onChange={onChange}
        options={{
          additionalContentStyleString:
            '.mce-content-body p:has(+ ol), .mce-content-body p:has(+ ul) { margin: 0; }',
          autoFocus: true,
          inline: true,
          onInit: () => setIsLoading(false),
          placeholder,
          toolbar: 'bold italic underline | bullist numlist | colorpreset',
        }}
        value={value}
      />
      {isLoading ?
        <SpinnerIcon height={32} width={32} />
      : <>
          <TextButton
            className='tw-mr-3 tw-mt-4'
            color='blue'
            onClick={onCancel}
            size='sm'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <ConditionalWrapper
            condition={!isSubmittable}
            wrapper={(children) => (
              <Tooltip
                placement='top'
                tooltip={i18nTShared('errors.blankTextField')}
                trigger='hover'
              >
                {children}
              </Tooltip>
            )}
          >
            <OutlinedButton
              color='grey'
              disabled={!isSubmittable}
              onClick={onSubmit}
              size='sm'
            >
              {submitButtonText}
            </OutlinedButton>
          </ConditionalWrapper>
        </>
      }
    </>
  );
}

SubmittableStepField.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  submitButtonText: PropTypes.string.isRequired,
  value: PropTypes.string,
};
